import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

console.log('PDF Export utils loaded');

// Translation helper
const translations = {
  id: {
    details: 'DETAIL',
    generated: 'Dibuat',
    invoice: 'FAKTUR',
    invoice_num: 'Faktur #',
    date: 'Tanggal',
    customer: 'Pelanggan',
    property: 'Properti',
    amount: 'Jumlah'
  },
  en: {
    details: 'DETAILS',
    generated: 'Generated',
    invoice: 'INVOICE',
    invoice_num: 'Invoice #',
    date: 'Date',
    customer: 'Customer',
    property: 'Property',
    amount: 'Amount'
  }
};

const t = (key, lang = 'id') => translations[lang][key] || key;

// Validate and sanitize input data
const validateInput = (input) => {
  if (typeof input === 'string') {
    return input.replace(/<script[^>]*>.*?<\/script>/gi, '')
      .replace(/<[^>]*>/g, '')
      .replace(/javascript:/gi, '')
      .trim();
  }
  return input;
};

// Export single record as PDF
export const exportSingleRecord = (record, filename, type = 'record', language = 'id') => {
  console.log('exportSingleRecord called:', record, filename, type, 'language:', language);

  try {
    // Validate inputs
    if (!record || typeof record !== 'object') {
      throw new Error('Invalid record data');
    }

    const doc = new jsPDF();

    // Primary color for admin
    const primaryColor = [59, 130, 246]; // Blue for admin

    // Header with colored background
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, 210, 35, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(16);
    doc.text(`${validateInput(type).toUpperCase()} ${t('details', language)}`, 20, 20);

    // Date
    doc.setFontSize(10);
    const dateStr = language === 'id' ? new Date().toLocaleDateString('id-ID') : new Date().toLocaleDateString('en-US');
    doc.text(`${t('generated', language)}: ${dateStr}`, 20, 30);

    // Reset text color
    doc.setTextColor(0, 0, 0);

    // Record details with sanitization
    let yPos = 50;
    Object.entries(record).forEach(([key, value]) => {
      if (key !== 'profile_photo' && key !== 'password' && key !== 'image') {
        const label = validateInput(key.replace(/_/g, ' ')).toUpperCase();
        const displayValue = validateInput(String(value || '-'));

        doc.setFontSize(10);
        doc.text(`${label}: ${displayValue}`, 20, yPos);
        yPos += 10;
      }
    });

    const cleanName = validateInput(String(record.name || record.title || 'record')).replace(/[^a-zA-Z0-9]/g, '_');
    const cleanType = validateInput(String(type)).replace(/[^a-zA-Z0-9]/g, '_');
    const fileName = `${cleanType}_${cleanName}_${record.id}_${new Date().toISOString().split('T')[0]}.pdf`;
    console.log('Saving single record PDF:', fileName);
    doc.save(fileName);
    console.log('Single record PDF saved');

  } catch (error) {
    console.error('Single record export error:', error);
    throw error;
  }
};

// Export invoice/receipt
export const exportInvoice = (booking, payment, language = 'id') => {
  console.log('exportInvoice called:', booking, payment, 'language:', language);

  try {
    const doc = new jsPDF();

    // Simple invoice
    doc.setFontSize(16);
    doc.text(t('invoice', language), 20, 20);

    doc.setFontSize(10);
    const dateStr = language === 'id' ? new Date().toLocaleDateString('id-ID') : new Date().toLocaleDateString('en-US');
    doc.text(`${t('invoice_num', language)}: ${validateInput(String(booking?.id || 'N/A'))}`, 20, 40);
    doc.text(`${t('date', language)}: ${dateStr}`, 20, 50);
    doc.text(`${t('customer', language)}: ${validateInput(booking?.user?.name || 'N/A')}`, 20, 60);
    doc.text(`${t('property', language)}: ${validateInput(booking?.property?.name || 'N/A')}`, 20, 70);
    doc.text(`${t('amount', language)}: Rp ${Number(booking?.total_amount || 0).toLocaleString()}`, 20, 80);

    const customerName = validateInput(booking?.user?.name || 'customer').replace(/[^a-zA-Z0-9]/g, '_');
    const fileName = `invoice_${customerName}_${booking?.id}_${new Date().toISOString().split('T')[0]}.pdf`;
    console.log('Saving invoice PDF:', fileName);
    doc.save(fileName);
    console.log('Invoice PDF saved');

  } catch (error) {
    console.error('Invoice export error:', error);
    throw error;
  }
};

// Test function
export const testPDF = () => {
  console.log('Testing PDF generation...');
  try {
    const doc = new jsPDF();
    doc.text('Test PDF', 20, 20);
    doc.save('test.pdf');
    console.log('Test PDF created successfully');
  } catch (error) {
    console.error('Test PDF failed:', error);
  }
};